import "@/App.css";
import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import MasterPanel from "@/pages/MasterPanel";
import SirucRecords from "@/pages/SirucRecords";
import SirucTickets from "@/pages/SirucTickets";
import SirucRecordDetail from "@/pages/SirucRecordDetail";
import SirucInspections from "@/pages/SirucInspections";
import SirucInspectionForm from "@/pages/SirucInspectionForm";
import BitacoraPage from "@/pages/BitacoraPage";
import Recorridos from "@/pages/Recorridos";
import RecorridoDetail from "@/pages/RecorridoDetail";
import RecorridoForm from "@/pages/RecorridoForm";
import Chat from "@/pages/Chat";
import Notifications from "@/pages/Notifications";
import Users from "@/pages/Users";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-navy font-bold uppercase tracking-tighter">Cargando aplicación...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function RoleGuard({ roles, children }) {
  const { user } = useAuth();
  // Si no hay usuario o su rol no está permitido, redirigir al inicio (Dashboard)
  if (!user || !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route index element={<Dashboard />} />

        {/* Solo Admin y Supervisor pueden ver el Panel Maestro */}
        <Route
          path="master"
          element={
            <RoleGuard roles={["admin", "supervisor"]}>
              <MasterPanel />
            </RoleGuard>
          }
        />

        <Route path="siruc/records" element={<SirucRecords />} />
        <Route path="siruc/tickets" element={<SirucTickets />} />
        <Route path="siruc/records/:id" element={<SirucRecordDetail />} />
        <Route path="siruc/inspections" element={<SirucInspections />} />
        <Route path="siruc/inspections/new" element={<SirucInspectionForm />} />
        <Route path="siruc/inspections/edit/:inspId" element={<SirucInspectionForm />} />

        <Route path="bitacora/:tipo" element={<BitacoraPage />} />

        <Route path="recorridos" element={<Recorridos />} />
        <Route path="recorridos/new" element={<RecorridoForm />} />
        <Route path="recorridos/:id" element={<RecorridoDetail />} />

        <Route path="chat" element={<Chat />} />
        <Route path="notifications" element={<Notifications />} />

        <Route
          path="users"
          element={
            <RoleGuard roles={["admin", "supervisor"]}>
              <Users />
            </RoleGuard>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
      <Toaster />
    </AuthProvider>
  );
}

export default App;
